import { useQuery } from "@tanstack/react-query";
import { AUTH_USER_KEY,getAuthUser } from "../queries/auth-query";

export const useAuthUser = () => {
    return useQuery({
        queryKey: AUTH_USER_KEY,
        queryFn: getAuthUser,
        staleTime: Infinity,
        gcTime: Infinity

    })
}